import styled from "styled-components";
import { ButtonContainerStyled as ButtonContainer, RenameForm, RenameInput } from "../RenameColumn/RenameColumnStyled";

export const CreateColumnFormStyled = styled(RenameForm)``;

export const CreateColumnNameInput = styled(RenameInput)``;

export const ButtonContainerStyled = styled(ButtonContainer)``;
